/**
 * 奖期高亮规则
 */
export function remarkIssue(alias, history){
	// 只有以下彩种会被接受高亮奖期
	const receiveLotterys = ['cq30s'];
	if (!_.includes(receiveLotterys, alias)) {
		return history;
	}

	switch(alias){
		case 'cq30s': {
			const issues = ['0060','0100','0140','0180','0220','0260','0300','0340','0380','0900','0940','0980','1020','1060','1100','1140','1180','1220','1260','1300','1340','1380','1420','1460','1500','1540','1580','1620','1660','1700','1740','1780','1820','1860','1900','1940','1980','2020','2060','2100','2140','2180','2220','2260','2300','2340','2380','2420','2460','2500','2540','2580','2620','2660','2700','2740','2780','2820','2860'];
			return rebuildIssue(issues, history)
		}
	}
}


/**
 * 为高亮的奖期加class
 * @author ammo 2018-06-25
 * @param  {[type]} issues  [description]
 * @param  {[type]} history [description]
 * @return {[type]}         [description]
 */
export function rebuildIssue(issues, history){
	_.each(history, function(item){
		if (_.includes(issues, _.split(item.issue, '-')[1])) {
			item.issueClass = 'high-light';
		}
	})
	return history;
}